import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ConfigHeaders } from '../models/config-headers.model';

/** Service to retrieve configuration headers */
@Injectable()
export class ConfigHeadersService {
  private headers?: ConfigHeaders;

  constructor(
    private readonly http: HttpClient,
  ) {}

  /** return configuration from headers, it will use cached value if exist */
  public getHeaders(): Observable<ConfigHeaders> {
    if (this.headers) {
      return of(this.headers);
    }

    return this.requestHeader().pipe(map((h) => {
      this.headers = h;
      return h;
    }));
  }

  /** request JSON with params maping and load headers */
  private requestHeader(): Observable<ConfigHeaders> {
    return this.http.get<ConfigHeaders>(
      '/assets/env.json', { observe: 'response' },
    ).pipe(catchError((err) => {
        if (!environment.production) {
          // tslint:disable-next-line: no-console
          console.error('Error loading env from assets', err);
        }
        return of(undefined);
      }),
        map((res) => {
          const defConfig = buildDefaultConfig();
          if (!res || !res.ok || !res.body) { return defConfig; }
          const paramsMap = res.body;
          const getHeader = (k: keyof ConfigHeaders) =>
            getHeaderValue(k, res.headers, paramsMap);
          return {
            authUrl: getHeader('authUrl'),
            realm: getHeader('realm'),
            clientId: getHeader('clientId'),
          } as ConfigHeaders;
        }),
      );
  }
}

// tslint:disable-next-line: only-arrow-functions
function buildDefaultConfig(): ConfigHeaders {
  return {
    authUrl: 'https://licences-demo.interiware-ng.com/auth/',
    realm: 'SAM-LICENSING',
    clientId: 'sam-licensing-front',
  };
}

// tslint:disable-next-line: only-arrow-functions
function getHeaderValue(
  key: keyof ConfigHeaders,
  headers: HttpHeaders,
  keyMap: ConfigHeaders,
): string {
  return headers.get(keyMap[key]) || buildDefaultConfig()[key];
}
